export default __webpack_public_path__ + "static/media/gournay14.fa72306d.jpg";